import React from 'react';
import NavigationBar from '../../navigationbar';
import Footer from '../../footer';

import img1 from '../../assets/Yoga/alle/group-of-young-sporty-people-in-uttanasana-exercise.jpg';
import img2 from '../../assets/Yoga/alle/group-of-young-sporty-people-sitting-in-padmasana-pose.jpg';
import wegbeschreibung from '../../assets/FotoWegbeschreibungAlteSchule.png';

function YogaAlle() {
  return (
    <>
        <NavigationBar/>
        <section className='schwanger-head'>
          <div className='schwanger-img-container'>
            <div className='image-wrapper'>
              <img src={img1} className='schwanger-img' alt="schwanger1"/>
            </div>
          </div>
          <div className='schwanger-img-container'>
            <div className='image-wrapper'>
              <img src={img2} className='schwanger-img' alt="schwanger2"/>
            </div>
          </div>
        </section>
        <section className='schwanger-head-label'>
          <h2>Yoga für Alle</h2>          
          <p>In diesem Kurs kräftigst du ganz individuell deinen ganzen Körper für die Herausforderungen des Alltags. Ich bringe dir bei, wie du Stress lösen kannst, körperlich und geistig. Für mehr Entspannung und ein insgesamt positiveres Leben!</p>
        </section>

        <section className='yoga-alle-details'>
            <h3>Wann & wo findet der Kurs statt?</h3>
            <br/>
            <p><strong>Dienstags 19.15 bis 20.30 Uhr</strong></p>
            <p><strong>Donnerstags 18:15 bis 19.30 Uhr</strong></p>
            <hr className='solid'/>
            <p>in der Alten Schule Lauenbrück <br/>Den Eingang findet ihr in Richtung Spielplatz der neuen Schule (siehe Foto). </p>
            <img src={wegbeschreibung} className='schwanger-img' alt="wegbeschreibung-alte-schule"/>
            <hr className='solid'/>
            <br/>
            <h3>Was bietet dir der Kurs?</h3>
            <ul>
              <li>Komme in Bewegung und erfahre die positiven und entspannenden Wirkungen der Streckung und Dehnung durch Yoga</li>
              <li>Übe Stück für Stück aus deiner körperlichen Komfortzone heraus zu kommen, um deinem Körper neue Kraft zu schenken</li>
              <li>Trainiere alltagstaugliche Techniken für mehr Entspannung und ein positives Selbstwertgefühl</li>
              <li>Lerne, wie du körperliche Beschwerden durch gezielte Übungen lindern oder ihnen vorbeugen kannst</li>
            </ul>
            <br/>
            <hr className='solid'/>
            <br/>
            <h3>Was brauchst du für den Kurs?</h3>
            <br/>
            <p>Bitte bring dir folgendes zu jedem Kurstag mit:</p>
            <ul>
              <li>eine eigene Matte</li>
              <li>eine leichte (Woll-)<strong>Decke</strong></li>
              <li>ein <strong>Getränk</strong></li>
            </ul>
            <br/>
            <p>Wenn du eigene Blöcke hast, kannst du diese auch gerne mitbringen.</p>
            <br/>
        </section>

        <section className='yoga-alle-kosten'>
          <div className='yoga-alle-details'>
            <h3>Kosten</h3>
            <p>10 Euro pro Termin, buchbar als 10er-Karte für die nächsten 10 aufeinander folgenden Termine.
               {/* <br/>Du kannst 10x innerhalb von 12 aufeinander folgenden Terminen den Kurs besuchen. */}
            </p>
                {/* <p className='schwanger-center-p'><strong>Der nächste Kurs läuft vom 11.01.-14.03.2024 (9 Termine) und ist 
                &nbsp;<a href="https://www.vhs-row.de/programm/kurs/Yoga-fuer-alle/BD71025" target='_blank' rel="noopener noreferrer">hier</a> buchbar!</strong>
                </p> */}
            <p >Der Kurs ist fortlaufend. Du kannst jederzeit schnuppern, einsteigen oder dich auf die Warteliste setzen lassen.
                <br/>
                Du kannst dich für die Kurse bei<a href='/kontakt'><strong>mir</strong></a>anmelden.
                <br/>
                Trau dich auch gerne mich anzusprechen, falls du eine persönliche Lösung bezüglich Kosten oder Teilnahme brauchst!
            </p>
          </div>
          
        </section>
        <Footer color="yoga"/>
    </>
  );
}

export default YogaAlle;
